namespace GeniuzPOS.Member {
    export class MbReport_01_Dt_PluColumns {
        static columnsKey = 'Member.MbReport_01_Dt_Plu';
    }
}
